import { Injectable } from '@angular/core';
import { UserInfoService, PlatformDataService } from '@ecap3/core';
import { ARC_CONFIG } from '../constant/arc-config.constant';

@Injectable()
export class SecurityPermissionService {


    constructor(private userInfoService: UserInfoService,
        private platformDataService: PlatformDataService) {
    }

    // getUserRole(loggedInUserRoles?) {
    //     let userRoles = loggedInUserRoles || this.userInfoService.userInfo.Roles;
    //     if (userRoles && userRoles.length) {
    //         if (userRoles.indexOf(ARC_CONFIG.Roles.FeatureAdmin) > -1)
    //             return ARC_CONFIG.Roles.FeatureAdmin;
    //     }
    //     return '';
    // }

    getUserRole(loggedInUserRoles?) {
        let userRoles = loggedInUserRoles || this.userInfoService.userInfo.Roles;
        if (userRoles && userRoles.length) {
            if (userRoles.indexOf('appuser') > -1)
                return 'appuser';
        }
        return '';
    }

}
